<section
    class="fluid-container hero-image"
    [ngStyle]="{ 'background-image': 'url(' + hero + ')' }"
>
    <div class="container d-none d-md-block">
        <div class="d-flex justify-content-around">
            <div
                class="card rounded-0 shadow col-xl-5 col-lg-5 col-md-5 border-0 mt-5"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-auto d-lg-block d-none text-primary">
                            <i class="fas fa-home fa-3x"></i>
                        </div>
                        <div class="col">
                            <h2 class="card-title">
                                {{
                                    'hero-card-residential-title'
                                        | cmsText
                                        | async
                                }}
                            </h2>
                            <p>
                                {{
                                    'hero-card-residential-text'
                                        | cmsText
                                        | async
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card-footer border-0 bg-white text-center">
                    <button
                        class="btn btn-primary btn-lg"
                        [routerLink]="'../register'"
                        id="register-button"
                    >
                        <app-content key="register-button-text"></app-content>
                        <i class="fa fa-chevron-right ms-2"></i>
                    </button>
                </div>
            </div>

            <div
                class="card rounded-0 shadow col-xl-5 col-lg-5 col-md-5 border-0 mt-5"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-auto d-lg-block d-none text-primary">
                            <i class="fas fa-building fa-3x"></i>
                        </div>
                        <div class="col">
                            <h2 class="card-title">
                                {{
                                    'hero-card-commercial-title'
                                        | cmsText
                                        | async
                                }}
                            </h2>
                            <p>
                                {{
                                    'hero-card-commercial-text'
                                        | cmsText
                                        | async
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card-footer border-0 bg-white text-center">
                    <button
                        class="btn btn-primary btn-lg"
                        [routerLink]="smeRegisterLink"
                        id="register-button"
                    >
                        <app-content key="register-button-text"></app-content>
                        <i class="fa fa-chevron-right ms-2"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container d-block d-md-none mt-n3">
    <div class="card rounded-0 shadow col-12 border-0">
        <div class="card-body">
            <div class="row">
                <div class="col-auto text-primary">
                    <i class="fas fa-home fa-5x"></i>
                </div>
                <div class="col">
                    <h2 class="card-title">
                        {{ 'hero-card-residential-title' | cmsText | async }}
                    </h2>
                    <p>
                        {{ 'hero-card-residential-text' | cmsText | async }}
                    </p>
                </div>
            </div>
        </div>
        <div class="card-footer border-0 bg-white text-center">
            <button
                class="btn btn-primary btn-lg"
                [routerLink]="'../register'"
                id="register-button"
            >
                <app-content key="register-button-text"></app-content>
                <i class="fa fa-chevron-right ms-2"></i>
            </button>
        </div>
    </div>

    <div class="card rounded-0 shadow col-12 border-0 mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-auto text-primary">
                    <i class="fas fa-building fa-5x"></i>
                </div>
                <div class="col">
                    <h2 class="card-title">
                        {{ 'hero-card-commercial-title' | cmsText | async }}
                    </h2>
                    <p>
                        {{ 'hero-card-commercial-text' | cmsText | async }}
                    </p>
                </div>
            </div>
        </div>
        <div class="card-footer border-0 bg-white text-center">
            <button
                class="btn btn-primary btn-lg"
                [routerLink]="smeRegisterLink"
                id="register-button"
            >
                <app-content key="register-button-text"></app-content>
                <i class="fa fa-chevron-right ms-2"></i>
            </button>
        </div>
    </div>
</section>

<section class="container my-5">
    <div class="row align-items-center justify-content-around">
        <div class="col-lg-4 col-md-6 my-auto">
            <h3 class="mb-3">
                <app-content key="why-signup-title"></app-content>
            </h3>
            <ul class="fa-ul ms-0">
                <li class="m-1">
                    <p class="lead">
                        <i class="text-primary fa fa-check"></i>
                        <app-content
                            class="ms-3"
                            key="why-signup-bullet-1-text"
                        ></app-content>
                    </p>
                </li>
                <li class="m-1 mt-3">
                    <p class="lead">
                        <i class="text-primary fa fa-check"></i>
                        <app-content
                            class="ms-3"
                            key="why-signup-bullet-2-text"
                        ></app-content>
                    </p>
                </li>
                <li class="m-1 mt-3">
                    <p class="lead">
                        <i class="text-primary fa fa-check"></i>
                        <app-content
                            class="ms-3"
                            key="why-signup-bullet-3-text"
                        ></app-content>
                    </p>
                </li>
            </ul>
        </div>
        <div class="col-md-6">
            <div class="row">
                <div class="col-4 mt-md-0 mt-5">
                    <div class="text-md-center text-start">
                        <img
                            class="img-fluid my-auto"
                            [attr.src]="'group-icon-img' | cmsImageSrc | async"
                            [attr.alt]="'group-icon-img' | cmsImageAlt | async"
                        />
                    </div>
                </div>
                <div class="col-8 mt-md-0 mt-5">
                    <h2>
                        {{
                            'participant-count-title'
                                | cmsText
                                    : [
                                          {
                                              participantCount:
                                                  (participantCount$
                                                  | async
                                                  | number),
                                          },
                                      ]
                                | async
                        }}
                    </h2>
                    <span
                        [innerHTML]="'participant-count-text' | cmsText | async"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="fluid-container bg-light mt-5">
    <div class="container pb-5 pt-4">
        <div class="row row-cols-1 justify-content-between pb-4 pt-5">
            <div
                *ngFor="let item of infoBullets"
                class="card link-box col-md-4 col-12 my-md-0 my-5 border-0 hoverable"
            >
                <a
                    [routerLink]="item.routerLink"
                    id="{{ 'moreInfo-bullet-' + item.id }}"
                >
                    <div
                        class="col-xl-5 col-lg-6 col-md-8 col-sm-10 col-5 mx-auto card-icon"
                    >
                        <img
                            class="rounded-circle img-fluid bg-white mt-sm-n5 mt-n0"
                            [attr.src]="
                                'hero-bullet-' + item.id + '-img'
                                    | cmsImageSrc
                                    | async
                            "
                            [attr.alt]="
                                'hero-bullet-' + item.id + '-img'
                                    | cmsImageAlt
                                    | async
                            "
                        />
                    </div>
                    <div class="pt-2 pb-4 px-md-2">
                        <i class="fa fa-chevron-right float-end"></i>
                        <h3
                            class="card-title h6 fw-bold link-box-title text-md-center"
                            [innerHTML]="
                                'hero-bullet-' + item.id + '-title'
                                    | cmsText
                                    | async
                            "
                        ></h3>
                        <p
                            class="card-text link-box-text"
                            [innerHTML]="
                                'hero-bullet-' + item.id + '-text'
                                    | cmsText
                                    | async
                            "
                        ></p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>

<section class="fluid-container py-5">
    <div class="container py-0 py-md-5">
        <h3 class="text-center mb-5">
            {{ 'testimonials-title' | cmsText | async }}
        </h3>
        <div class="row">
            <ng-container *ngFor="let i of [1, 2, 3]">
                <div class="col-md-4 mb-md-0 mb-4">
                    <div class="card h-100 py-3 border-primary text-center">
                        <div class="card-body">
                            <p
                                class="h4"
                                [innerHTML]="
                                    'testimonials-catchphrase-' + i
                                        | cmsText
                                        | async
                                "
                            ></p>
                            <p
                                class="my-4"
                                [innerHTML]="
                                    'testimonials-text-' + i | cmsText | async
                                "
                            ></p>
                            <p
                                class="h6"
                                [innerHTML]="
                                    'testimonials-name-' + i | cmsText | async
                                "
                            ></p>
                            <span
                                class="text-muted"
                                [innerHTML]="
                                    'testimonials-location-' + i
                                        | cmsText
                                        | async
                                "
                            ></span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</section>

<section class="fluid-container text-start text-md-center bg-light py-5">
    <div class="container py-0 py-md-5">
        <h3 class="mb-0 mb-md-5 mb-5">
            <span [innerHTML]="'how-it-works-title' | cmsText | async"></span>
        </h3>
        <div class="d-flex justify-content-between row">
            <div
                *ngFor="let item of [1, 2, 3, 4]"
                class="col-md-3 col-12 my-3 my-md-0"
            >
                <div class="row">
                    <div class="col-md-7 col-3 mx-auto">
                        <img
                            class="img-fluid rounded-circle bg-light p-3"
                            [attr.src]="
                                'how-it-works-bullet-' + item + '-img'
                                    | cmsImageSrc
                                    | async
                            "
                            [attr.alt]="
                                'how-it-works-bullet-' + item + '-img'
                                    | cmsImageAlt
                                    | async
                            "
                        />
                    </div>
                    <div class="col-md-12 col-9 my-auto">
                        <h3 class="h6 fw-bold mt-0 mt-md-3">
                            <span
                                [innerHTML]="
                                    'how-it-works-bullet-' + item + '-title'
                                        | cmsText
                                        | async
                                "
                            ></span>
                        </h3>
                        <p>
                            <span
                                [innerHTML]="
                                    'how-it-works-bullet-' + item + '-text'
                                        | cmsText
                                        | async
                                "
                            ></span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-5 text-center">
            <a
                [routerLink]="'../info'"
                id="moreInfo"
                class="btn btn-outline-primary text-uppercase ms-auto me-auto px-5"
            >
                {{ 'more-info-button-text' | cmsText | async
                }}<i class="fa fa-chevron-right ms-2"></i>
            </a>
        </div>
    </div>
</section>

<section class="fluid-container py-5">
    <div class="container py-0 py-md-5">
        <div class="row align-items-center justify-content-around">
            <div class="col-md-6">
                <div
                    youtubemovie="0fZWZrq4UTw"
                    class="ratio ratio-16x9 embed-responsive rounded mb-3 mb-md-0 shadow-sm"
                ></div>
            </div>
            <div class="col-md-6">
                <div
                    youtubemovie="n7u-Tr-S2LA"
                    class="ratio ratio-16x9 embed-responsive rounded mb-3 mb-md-0 shadow-sm"
                ></div>
            </div>
        </div>
    </div>
</section>

<section class="container-fluid py-5 bg-light">
    <div class="container py-0 py-md-5">
        <h3
            class="text-center"
            [innerHTML]="'past-winning-supplier-title' | cmsText | async"
        ></h3>
        <div class="row justify-content-center py-3">
            <ng-container *ngFor="let logoCmsKey of logosCmsKeys$ | async">
                <div class="logo-wrapper col-md-2 col-4 p-3">
                    <img
                        class="logo h-100 w-100"
                        [attr.src]="logoCmsKey | cmsImageSrc | async"
                        [attr.alt]="logoCmsKey | cmsImageAlt | async"
                    />
                </div>
            </ng-container>
        </div>
    </div>
</section>

<section class="fluid-container py-5">
    <div class="container d-none d-md-block">
        <div class="d-flex justify-content-around">
            <div
                class="card rounded-0 shadow col-xl-5 col-lg-5 col-md-5 border-0"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-auto d-lg-block d-none text-primary">
                            <i class="fas fa-home fa-3x"></i>
                        </div>
                        <div class="col">
                            <h2 class="card-title">
                                {{
                                    'hero-card-residential-title'
                                        | cmsText
                                        | async
                                }}
                            </h2>
                            <p>
                                {{
                                    'hero-card-residential-text'
                                        | cmsText
                                        | async
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card-footer border-0 bg-white text-center">
                    <button
                        class="btn btn-primary btn-lg"
                        [routerLink]="'../register'"
                        id="register-button"
                    >
                        <app-content key="register-button-text"></app-content>
                        <i class="fa fa-chevron-right ms-2"></i>
                    </button>
                </div>
            </div>

            <div
                class="card rounded-0 shadow col-xl-5 col-lg-5 col-md-5 border-0"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-auto d-lg-block d-none text-primary">
                            <i class="fas fa-building fa-3x"></i>
                        </div>
                        <div class="col">
                            <h2 class="card-title">
                                {{
                                    'hero-card-commercial-title'
                                        | cmsText
                                        | async
                                }}
                            </h2>
                            <p>
                                {{
                                    'hero-card-commercial-text'
                                        | cmsText
                                        | async
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card-footer border-0 bg-white text-center">
                    <button
                        class="btn btn-primary btn-lg"
                        [routerLink]="smeRegisterLink"
                        id="register-button"
                    >
                        <app-content key="register-button-text"></app-content>
                        <i class="fa fa-chevron-right ms-2"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="container d-block d-md-none">
        <div class="card rounded-0 shadow col-12 border-0">
            <div class="card-body">
                <div class="row">
                    <div class="col-auto text-primary">
                        <i class="fas fa-home fa-5x"></i>
                    </div>
                    <div class="col">
                        <h2 class="card-title">
                            {{
                                'hero-card-residential-title' | cmsText | async
                            }}
                        </h2>
                        <p>
                            {{ 'hero-card-residential-text' | cmsText | async }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="card-footer border-0 bg-white text-center">
                <button
                    class="btn btn-primary btn-lg"
                    [routerLink]="'../register'"
                    id="register-button"
                >
                    <app-content key="register-button-text"></app-content>
                    <i class="fa fa-chevron-right ms-2"></i>
                </button>
            </div>
        </div>

        <div class="card rounded-0 shadow col-12 border-0 mt-3">
            <div class="card-body">
                <div class="row">
                    <div class="col-auto text-primary">
                        <i class="fas fa-building fa-5x"></i>
                    </div>
                    <div class="col">
                        <h2 class="card-title">
                            {{ 'hero-card-commercial-title' | cmsText | async }}
                        </h2>
                        <p>
                            {{ 'hero-card-commercial-text' | cmsText | async }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="card-footer border-0 bg-white text-center">
                <button
                    class="btn btn-primary btn-lg"
                    [routerLink]="smeRegisterLink"
                    id="register-button"
                >
                    <app-content key="register-button-text"></app-content>
                    <i class="fa fa-chevron-right ms-2"></i>
                </button>
            </div>
        </div>
    </div>
</section>
